import { FC } from "react";
import { Box, Card, Grid, Stack } from "@mui/material";
import { ChartlistProps } from "../types";
import { RatioChart } from "../../CustomChart/RatioChart";

type Ratio = {
  label: string;
  value: number;
};

export const RatioList: FC<ChartlistProps<Ratio>> = ({ items, label }) => {
  const isGrid = items.length > 4;

  return (
    <Box>
      {isGrid ? (
        <Grid container spacing={2}>
          {items.map((ratio, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  height: 165,
                  borderRadius: 2,
                }}
              >
                <RatioChart label={ratio.label} value={ratio.value} />
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Stack spacing={2} direction="row">
          {items.map((ratio, index) => (
            <Card
              key={index}
              sx={{
                width: "100%",
                maxWidth: 700,
                minWidth: 140,
                height: 165,
                borderRadius: 2,
              }}
            >
              <RatioChart label={ratio.label} value={ratio.value} />
            </Card>
          ))}
        </Stack>
      )}
    </Box>
  );
};
